import useAsyncFn from 'react-use/lib/useAsyncFn';

import { shortenUrl } from '../utils/share';

export const useShortUrl = (payload: Parameters<typeof shortenUrl>[0]) =>
  useAsyncFn<() => Promise<string>>(
    () => shortenUrl(payload).then(data => data.short_url),
    [payload],
  );
